// extracted by mini-css-extract-plugin
export default {"fullContainer":"App_fullContainer__FbBiY","row":"App_row__fKlzF","content":"App_content__dqni4"};